import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 项目期初类型
 */
class StorageInceptionType extends UltMeta {
    BUY = new Meta(1, "入库明细");
    SELL = new Meta(2, "出库明细");
}

export const STORAGE_INCEPTION_TYPE = new StorageInceptionType();

/**
 * 仓储信息-业务类型
 */
class StorageBusinessType extends UltMeta {
    IN_STORAGE = new Meta(1, "入库");
    OUT_STORAGE = new Meta(2, "出库");
}

export const STORAGE_BUSINESS_TYPE = new StorageBusinessType();
